import type { App } from 'vue';
import { createPinia } from 'pinia';

const store = createPinia();

export function setupStore(app: App<Element>) {
    app.use(store);
}

export { store };

/**
 * Pinia Store 统一导出
 */
export * from './project';
export * from './toolbar-command';
export * from './global';
export * from './auth';
export * from './cad-session';
export * from './part-tabs';
export * from './version-workspace';
export * from './version-preview';
export * from './assembly-branch-node-list';
